// Central definition of the Watchlist BidCard template gate. Read by
// PrefetchedWatchlistedListingsProvider (server), useListingStateURLRectification
// (client), and WatchlistContent (client) — hoisted so one flag rename can't
// leave the surfaces out of sync. Server-safe: no React or 'use client'
// imports, callable from either side of the RSC boundary.
export const isBidCardTemplateEnabled = (
  watchlistMyBidsTemplate: { enabled: boolean },
  inlineBidBoxEnabled: boolean
): boolean => watchlistMyBidsTemplate.enabled && inlineBidBoxEnabled
